import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-l",
  "use": "arrow-l-usage",
  "viewBox": "0 0 11.09 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.09 20\" id=\"arrow-l\"><title>arrow-l</title><path d=\"M4.93,11a1.18,1.18,0,0,1-.46-1c-.06-.36.22-.7.46-1L13.62.33a1.13,1.13,0,1,1,1.6,1.6L7,10l8.27,8.07a1.13,1.13,0,0,1-1.6,1.6Z\" transform=\"translate(-4.46 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/arrow-l.svg
// module id = HOFY
// module chunks = 268